export default function FloatingShapes({ color = '#6366F1', variant = 'circles' }) {
    const opacity = 0.08;

    if (variant === 'dots') {
        return (
            <div className="absolute inset-0 overflow-hidden pointer-events-none">
                <div className="absolute top-[10%] left-[5%] w-3 h-3 rounded-full" style={{ backgroundColor: color, opacity }} />
                <div className="absolute top-[25%] right-[15%] w-2 h-2 rounded-full" style={{ backgroundColor: color, opacity: opacity * 1.5 }} />
                <div className="absolute bottom-[20%] left-[20%] w-4 h-4 rounded-full" style={{ backgroundColor: color, opacity: opacity * 0.8 }} />
                <div className="absolute top-[60%] right-[8%] w-2.5 h-2.5 rounded-full" style={{ backgroundColor: color, opacity }} />
                <div className="absolute bottom-[10%] right-[30%] w-3.5 h-3.5 rounded-full" style={{ backgroundColor: color, opacity: opacity * 0.6 }} />
            </div>
        );
    }

    if (variant === 'blobs') {
        return (
            <div className="absolute inset-0 overflow-hidden pointer-events-none">
                <div className="absolute -top-20 -right-20 w-72 h-72 rounded-full blur-3xl" style={{ backgroundColor: color, opacity: opacity * 0.7 }} />
                <div className="absolute -bottom-16 -left-16 w-60 h-60 rounded-full blur-3xl" style={{ backgroundColor: color, opacity: opacity * 0.5 }} />
                <div className="absolute top-1/3 left-1/2 w-48 h-48 rounded-full blur-3xl" style={{ backgroundColor: color, opacity: opacity * 0.3 }} />
            </div>
        );
    }

    // Default: circles
    return (
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
            <div className="absolute -top-10 -right-10 w-40 h-40 rounded-full blur-2xl" style={{ backgroundColor: color, opacity }} />
            <div className="absolute -bottom-8 -left-8 w-32 h-32 rounded-full blur-2xl" style={{ backgroundColor: color, opacity: opacity * 0.8 }} />
            <div className="absolute top-1/2 right-1/4 w-24 h-24 rounded-full blur-2xl" style={{ backgroundColor: color, opacity: opacity * 0.5 }} />
            <div className="absolute top-1/4 left-1/3 w-20 h-20 rounded-full blur-xl" style={{ backgroundColor: color, opacity: opacity * 0.6 }} />
        </div>
    );
}
